import React, { useState, useEffect } from 'react';
import { Card, CircularProgress } from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';

import { Auth } from 'aws-amplify';

function AuthDebug() {
  const [accessToken, setAccessToken] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTokens = async () => {
      try {
        const session = await Auth.currentSession();
        setAccessToken(session.getAccessToken().getJwtToken());
        setIdToken(session.getIdToken().getJwtToken());
      } catch (err) {
        console.error('Error loading session:', err);
      } finally {
        setLoading(false);
      }
    };
    loadTokens();
  }, []);

  const handleLogout = async () => {
    try {
      await Auth.signOut({ global: true });
    } catch (err) {
      console.error('Error signing out:', err);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <SoftBox display="flex" justifyContent="center" alignItems="center" py={6}>
          <CircularProgress />
        </SoftBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox p={3}>
              <SoftTypography variant="h6" mb={2}>Access Token</SoftTypography>
              <pre style={{
                backgroundColor: '#f5f5f5',
                padding: '16px',
                borderRadius: '8px',
                overflow: 'auto',
                maxHeight: '300px',
                fontSize: '12px',
                wordBreak: 'break-all',
                whiteSpace: 'pre-wrap',
              }}>
                {accessToken || 'No access token available'}
              </pre>
            </SoftBox>
          </Card>
        </SoftBox>

        <SoftBox mb={3}>
          <Card>
            <SoftBox p={3}>
              <SoftTypography variant="h6" mb={2}>ID Token</SoftTypography>
              <pre style={{
                backgroundColor: '#f5f5f5',
                padding: '16px',
                borderRadius: '8px',
                overflow: 'auto',
                maxHeight: '300px',
                fontSize: '12px',
                wordBreak: 'break-all',
                whiteSpace: 'pre-wrap',
              }}>
                {idToken || 'No ID token available'}
              </pre>
            </SoftBox>
          </Card>
        </SoftBox>

        <SoftBox mb={3}>
          <SoftButton variant="gradient" color="error" onClick={handleLogout}>
            Logout (Global)
          </SoftButton>
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AuthDebug;
